import logo from './logo.svg';
import './App.css';
import React, { useState, useEffect, useRef } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './components/home';
import Navbar from './components/navbar';
import Footer from './components/footer';
import About from './components/about';
import Rules from './components/rules';
import GalleryPage from './components/gallery';
import Contact from './components/contact';
import RCN from './components/rcn';
import RCE from './components/rce';
import RITI from './components/riti';
import RSSS from './components/rsss';
import Billing from './components/billing';
import CheckStatus from './components/status';
import FileDownloader from './components/GetPaymentList';
import PdfListPage from './components/docs';
// import Courses from './components/courses';
// import About from './components/abous';
// import Gallery from './components/gallery';
// import Admission from './components/admission';
// import Fees from './components/fees';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
      <Navbar/>
        <Routes>
         
          <Route
            path=""
            element={<Home />}
          />
              
              <Route
            path="about-us"
            element={<About />}
          />
             <Route
            path="rules"
            element={<Rules />}
          />
            <Route
            path="gallery"
            element={<GalleryPage />}
          />
           <Route
            path="documents"
            element={<PdfListPage />}
          />
           <Route
            path="contact-us"
            element={<Contact />}
          />
            <Route
            path="rcn"
            element={<RCN />}
          />
             <Route
            path="rce"
            element={<RCE />}
          />
            <Route
            path="riti"
            element={<RITI />}
          />
            <Route
            path="rsss"
            element={<RSSS />}
          />
          <Route
            path="fees"
            element={<Billing />}
          />
           <Route
            path="payment-redirect/*"
            element={<CheckStatus />}
          />
           <Route
            path="payment-details"
            element={<FileDownloader />}
          />
       
        </Routes>
        <Footer/>
      </BrowserRouter >
    </div>
  );
}

export default App;
